// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.ContractList_info-message__kOxZf a {
  width: 100%;
  font-weight: 500;
  font-size: 16px;
}
.ContractList_info-message__kOxZf a:hover {
  text-decoration: none;
}

.ContractList_claim-button__xUnGW {
  width: 185px;
}

.ContractList_items__0CP70 {
  margin-top: 20px;
}

.ContractList_item__10oJ- {
  position: relative;
}
.ContractList_item__10oJ-:not(:last-child) {
  margin-bottom: 12px;
}

.ContractList_cards__8QVGO {
  list-style-type: none;
  font-weight: 300;
  padding: 0;
  margin: 0;
}

@media screen and (max-width: 600px) {
  .ContractList_info-message__kOxZf button {
    height: 35px;
  }
  .ContractList_claim-button__xUnGW {
    width: 100%;
  }
  .ContractList_items__0CP70 {
    margin-top: 28px;
  }
}
.ContractList_custom-info-message__VVxbQ {
  display: flex;
  align-items: center; /* Aligne verticalement */
  justify-content: space-between;
  background-color: #FEF9F0;
  border: 1px solid #FBD298;
  color: #B94402;
}
.ContractList_custom-info-message__VVxbQ + .ContractList_custom-info-message__VVxbQ {
  margin-top: 12px;
}

.ContractList_custom-claim-button__LXMzc {
  padding: 0 20px; /* Ajuster en fonction de la taille du texte */
  font-size: inherit; /* Pour qu'il suive la taille du texte */
  width: auto; /* S'assure que le bouton prend la taille du texte */
  white-space: nowrap; /* Empêche le texte de se couper en plusieurs lignes */
}

.ContractList_custom-claim-button__LXMzc:hover {
  background-color: #FEF9F0; /* Si vous voulez que le bouton change au hover */
}

.ContractList_contract-list-page__xC5-y .ContractList_card__hgONi {
  background: #f0f0f0; /* Appliquer à cette page uniquement */
  color: #333;
}
.ContractList_contract-list-page__xC5-y .ContractList_card__hgONi.ContractList_clickable__l70Ns:hover {
  outline: 1px solid #00ff00;
}
.ContractList_contract-list-page__xC5-y .ContractList_card__hgONi.ContractList_inactive__6OtfA {
  background: #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./src/components/Contracts/ContractList/ContractList.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAMd;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AAAI;EACE,qBAAA;AAEN;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAFF;;AAMA;EAEI;IACE,YAAA;EAJJ;EAQA;IACE,WAAA;EANF;EASA;IACE,gBAAA;EAPF;AACF;AASA;EACE,aAAA;EACA,mBAAA,EAAA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AAPF;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,eAAA,EAAA,8CAAA;EACA,kBAAA,EAAA,wCAAA;EACA,WAAA,EAAA,oDAAA;EACA,mBAAA,EAAA,sDAAA;AARF;;AAWA;EACE,yBAAA,EAAA,iDAAA;AARF;;AAYE;EACE,mBAAA,EAAA,sCAAA;EACA,WAAA;AATJ;AAWI;EACE,0BAAA;AATN;AAYI;EACE,mBAAA;AAVN","sourcesContent":["//@use 'styles/sizes.scss';\n\n@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.info-message {\n  a {\n    width: 100%;\n    font-weight: 500;\n    font-size: 16px;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.claim-button {\n  width: 185px;\n}\n\n.items {\n  margin-top: 20px;\n}\n\n.item {\n  position: relative;\n\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n}\n\n\n.cards{\n  list-style-type: none;\n  font-weight: 300;\n  padding: 0;\n  margin: 0;\n}\n\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .info-message {\n    button {\n      height: 35px;\n    }\n  }\n\n  .claim-button {\n    width: 100%;\n  }\n\n  .items {\n    margin-top: 28px;\n  }\n}\n.custom-info-message {\n  display: flex;\n  align-items: center; /* Aligne verticalement */\n  justify-content: space-between;\n  background-color: #FEF9F0;\n  border: 1px solid #FBD298;\n  color: #B94402;\n\n  +.custom-info-message{\n    margin-top: 12px;\n  }\n}\n\n.custom-claim-button {\n  padding: 0 20px; /* Ajuster en fonction de la taille du texte */\n  font-size: inherit; /* Pour qu'il suive la taille du texte */\n  width: auto; /* S'assure que le bouton prend la taille du texte */\n  white-space: nowrap; /* Empêche le texte de se couper en plusieurs lignes */\n}\n\n.custom-claim-button:hover {\n  background-color: #FEF9F0; /* Si vous voulez que le bouton change au hover */\n}\n\n.contract-list-page {\n  .card {\n    background: #f0f0f0; /* Appliquer à cette page uniquement */\n    color: #333;\n\n    &.clickable:hover {\n      outline: 1px solid #00ff00;\n    }\n\n    &.inactive {\n      background: #e0e0e0;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"info-message": `ContractList_info-message__kOxZf`,
	"claim-button": `ContractList_claim-button__xUnGW`,
	"items": `ContractList_items__0CP70`,
	"item": `ContractList_item__10oJ-`,
	"cards": `ContractList_cards__8QVGO`,
	"custom-info-message": `ContractList_custom-info-message__VVxbQ`,
	"custom-claim-button": `ContractList_custom-claim-button__LXMzc`,
	"contract-list-page": `ContractList_contract-list-page__xC5-y`,
	"card": `ContractList_card__hgONi`,
	"clickable": `ContractList_clickable__l70Ns`,
	"inactive": `ContractList_inactive__6OtfA`
};
export default ___CSS_LOADER_EXPORT___;
